<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex
        xs12
        md6>
        <MaterialCard
          dark
          hover
          color="busie"
          title="Register">
          <StandardForm
            ref="form"
            @submit="submit">
            <StandardInput
              v-model="payload.user.username"
              icon="mdi-account-circle"
              label="Username"/>
            <StandardInput
              v-model="payload.user.first_name"
              icon="mdi-account-outline"
              label="First Name"/>
            <StandardInput
              v-model="payload.user.last_name"
              icon="mdi-account-outline"
              label="Last Name"/>
            <StandardInput
              v-model="payload.user.email"
              icon="mdi-email"
              label="Email"/>
            <StandardInput
              v-model="payload.location"
              :disabled="true"
              icon="mdi-store"
              label="Company ID"/>
            <StandardInput
              v-model="payload.department"
              :disabled="true"
              icon="mdi-briefcase"
              label="Department ID"/>
            <StandardInput
              v-model="payload.password"
              icon="mdi-lock"
              label="Password"
              type="password"/>
            <StandardInput
              v-model="payload.confirmPassword"
              icon="mdi-check-all"
              label="Confirm Password"
              type="password"/>
            <CardActions>
              <StandardButton
                text="Register"
                @click="$refs.form.$emit(&quot;submit&quot;)" />
            </CardActions>
          </StandardForm>
        </MaterialCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import StandardForm from '@/components/busie/StandardForm'
import StandardInput from '@/components/busie/StandardInput'
import StandardButton from '@/components/busie/StandardButton'
import CardActions from '@/components/busie/CardActions'
import MaterialCard from '@/components/material/Card'
import { mapActions } from 'vuex'

export default {
  components: {
    StandardForm,
    StandardInput,
    StandardButton,
    CardActions,
    MaterialCard
  },
  data () {
    return {
      payload: this.createFreshForm()
    }
  },
  computed: {
    passwordsOk () {
      const pw = this.payload.user.password
      const pwc = this.payload.confirmPassword
      return pw && pwc && (pw === pwc)
    },
    location () {
      return this.$route.query.location
    },
    department () {
      return this.$route.query.department
    }
  },
  watch: {
    location: {
      handler (val) {
        this.mount()
      }
    },
    department: {
      handler (val) {
        this.mount()
      }
    }
  },
  mounted () {
    if (!(this.department && this.location)) {
      this.raiseError([
        'Registration can only be completed through a custom link, please contact your admin.'
      ])
    } else {
      this.payload.location = this.location
      this.payload.department = this.department
    }
  },
  methods: {
    submit () {
      if (this.passwordsOk) {
        this.raiseError(['Passwords must match!'])
        return
      }
      delete payload.confirmPassword
      const credentials = {
        username: this.payload.user.username,
        password: this.payload.user.Password
      }
      this.register(payload).then(
        () => this.login(credentials).then(
          res => this.setUser(res.data)).then(
          () => this.redirect())).catch(
        e => this.raiseError(e))
    },
    redirect () {
      this.createFreshForm()
      this.$router.replace('/dashboard')
    },
    createFreshForm: () => {
      return {
        user: {
          username: null,
          password: null,
          first_name: null,
          last_name: null,
          email: null
        },
        location: null,
        department: null,
        confirmPassword: null
      }
    },
    ...mapActions('auth', ['register']),
    ...mapActions('app', ['raiseError']),
    ...mapActions('user', ['setUser'])
  }
}
</script>

<style lang="css" scoped>
</style>
